import React from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Loader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

const Message = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.color1};
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  svg {
    margin-right: 30px;
  }
`;

export default withTheme(({ message, theme }) => {
  return (
    <Loader>
      <Message>
        <FontAwesomeIcon
          icon={["fas", "spinner"]}
          size="2x"
          color={theme.color1}
          spin
        />
        {message || ""}
      </Message>
    </Loader>
  );
});
